/* import __COLOCATED_TEMPLATE__ from './cardless-conversion-modal-pricing5.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';

interface Signature {
  Args: {
    model: {
      onOpenChange: (open: boolean) => void;
      activePlanId?: number;
      oneDollarTrialExtension: boolean;
      selfServe: boolean;
      canUseEarlyStageDetection: boolean;
      canUseProductSpecialistCTAs: boolean;
      earlyStageDiscount: number;
    };
  };
}

export default class CardlessConversionModalPricing5 extends Component<Signature> {
  get contextualLinkVariant() {
    if (this.args.model.canUseEarlyStageDetection) {
      return 'early_stage';
    } else if (this.args.model.canUseProductSpecialistCTAs) {
      return 'ask_product_specialist';
    } else {
      return 'talk_to_sales';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Modal::CardlessConversionModalPricing5': typeof CardlessConversionModalPricing5;
    'react/modal/cardless-conversion-modal-pricing5': typeof CardlessConversionModalPricing5;
  }
}
